// eslint-disable-next-line
export function all(context, payload) {
  const getUrl = `/floorplans/`;

  return this._vm.$axios.get(getUrl).then((response) => {
    const { data } = response;
    // console.log('store.floorplans.actions.all() axios then', data, status, statusText);

    return context.dispatch('setFloorplans', { data: data.posts });
  });
}

export function setFloorplans(context, payload) {
  // console.log('store.quick-move-ins.actions.setQuickMoveIns()', payload);
  context.commit('setFloorplans', payload.data);

  return payload.data;
}
